<form class="my-3" [formGroup]="form" (ngSubmit)="submit()">
    <div formArrayName="questions">
        @for (q of questions.controls; track q; let qi = $index) {
            <div class="mb-4" [formGroupName]="qi">
                <mat-card class="mb-3 shadow-sm" appearance="outlined">
                    <div class="d-flex align-items-center justify-content-between">
                        <mat-form-field class="flex-grow-1 me-3">
                            <mat-label>Vraag {{ qi + 1 }}</mat-label>
                            <textarea
                                #questionInput
                                matInput
                                formControlName="question"
                                placeholder="Vraag tekst"
                                required
                                rows="1"
                                cdkTextareaAutosize></textarea>
                        </mat-form-field>
                        <button (click)="removeQuestion(qi)" mat-icon-button color="warn" type="button">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    <div class="ps-4 mt-3" formArrayName="choices">
                        @for (c of choices(getFormGroup(q)).controls; track c; let ci = $index) {
                            <div class="row mb-2 align-items-center" [formGroupName]="ci">
                                <div class="col-14">
                                    <mat-form-field class="w-100">
                                        <mat-label>Keuze tekst</mat-label>
                                        <textarea
                                            #choiceInput
                                            matInput
                                            formControlName="text"
                                            placeholder="Keuze tekst"
                                            required
                                            rows="1"
                                            cdkTextareaAutosize></textarea>
                                    </mat-form-field>
                                </div>
                                <div class="col-6">
                                    <mat-checkbox formControlName="is_correct">Correct</mat-checkbox>
                                </div>
                                <div class="col-4 text-end">
                                    <button
                                        [disabled]="choices(getFormGroup(q)).length <= 1"
                                        (click)="removeChoice(getFormGroup(q), ci)"
                                        mat-icon-button
                                        color="warn"
                                        type="button">
                                        <mat-icon>remove_circle</mat-icon>
                                    </button>
                                </div>
                            </div>
                        }
                        <button
                            class="mt-2"
                            (click)="addChoice(getFormGroup(q))"
                            mat-stroked-button
                            color="primary"
                            type="button">
                            <mat-icon>add</mat-icon>
                            Keuze toevoegen
                        </button>
                    </div>
                </mat-card>
            </div>
        }
    </div>
    <div class="d-flex justify-content-between">
        <button class="me-2" (click)="addQuestion()" mat-raised-button color="primary" type="button">
            <mat-icon>add_circle</mat-icon>
            Vraag toevoegen
        </button>
        <button mat-raised-button color="accent" type="submit">
            <mat-icon>check_circle</mat-icon>
            Alles opslaan
        </button>
    </div>
</form>
